import type { ManagerRegistry } from '../../../core/manager-registry';
import type { RadialMenuItem } from '../types';
import { getIcon } from '../../../utils/icon-manager';

export const createSectionRadialButton = (registry: ManagerRegistry): RadialMenuItem => {
    return {
        id: 'section',
        label: 'toolbar.section',
        icon: getIcon('剖切'),
        isToggle: true,
        isActive: registry.bottomDock?.isOpen('section') ?? false,
        onToggle: (next) => {
            const dock = registry.bottomDock;
            if (!dock) {
                console.warn('[RadialToolbar] bottom dock not initialized: section');
                return;
            }

            if (next) {
                dock.open('section');
            } else {
                dock.close('section');
            }

            console.log(`[RadialToolbar] 剖切${next ? '已打开' : '已关闭'}`);
        }
    };
};
